import {
    LINKEDIN_CLIENT_ID,
    GOOGLE_CLIENT_ID,
    FACEBOOK_CLIENT_ID,
    TWITTER_CLIENT_ID
} from "../blink-sdk/Constants";

export {
    IS_PRODUCTION,
    TEST_MODE,
    BLINK_PAY_URL,
    ANALYTICS_ENABLED,
    BUILD_VERSION,
    BUILD_TIMESTAMP,
    WS_API_URL,
    STRIPE_PUBLIC_KEY,
    GOOGLE_PAY_ENV,
    SOUTHERN_THING_ALIAS,
} from "../blink-sdk/Constants";

export const BUTTON_TYPE = {
    PRIMARY: 0,
    SECONDARY: 1,
};

export const CONFIRMATION_CODE_TYPES = {
    LONG: "long",
    SHORT: "short",
};

export const DEFAULT_CONFIRMATION_CODE_TYPE = CONFIRMATION_CODE_TYPES.SHORT;

export const APP_NAME = "user_dashboard";

export const STRIPE_SRC = "https://js.stripe.com/v3/";

export const OAUTH2_CONFIGS = {
    linkedin: {
        clientId: LINKEDIN_CLIENT_ID,
        redirectUri: "/login-redirect/linkedin/",
        responseType: "code",
        scope: "r_liteprofile r_emailaddress",
        authServerUrl: "https://www.linkedin.com/oauth/v2/authorization",
        loginEndpoint: "/socialauth/linkedin/",
    },
    google: {
        clientId: GOOGLE_CLIENT_ID,
        redirectUri: "/login-redirect/google/",
        responseType: "code",
        scope: "email profile",
        authServerUrl: "https://accounts.google.com/o/oauth2/v2/auth",
        loginEndpoint: "/socialauth/google/",
    },
    facebook: {
        clientId: FACEBOOK_CLIENT_ID,
        redirectUri: "/login-redirect/facebook/",
        scope: "email",
        authServerUrl: "https://www.facebook.com/v6.0/dialog/oauth", // TODO: Come back to this on May 5th 2022 (preferably sooner tho).
        loginEndpoint: "/socialauth/facebook/",
    },
};

export const OAUTH1_CONFIGS = {
    twitter: {
        clientId: TWITTER_CLIENT_ID,
        redirectUri: "/login-redirect/twitter/",
        authServerUrl: "https://api.twitter.com/oauth/authorize",
        requestTokenEndpoint: "/socialauth/twitter/request_token/",
        loginEndpoint: "/socialauth/twitter/connect/",
    },
};

export const WEBSITE_MOBILE_SCREEN_MIN_WIDTH_SUPPORTED = 375;

export const MOBILE_DEVICE_SCREEN_WIDTH_LIMIT = 450; // TODO: this is a random number Mihai picked for CSAcademy, should be different

export const SMALL_SCREEN_WIDTH_LIMIT = 650;

export const ADD_FUNDS_DISABLE_TIMEOUT = 2000;

export const DEFAULT_DATE_FORMAT = "DD MMM YYYY";

export const MISSING_INFO = "-";

export const SUPPORT_EMAIL_ADDRESS = "support@blink.net";
export const BIZ_SUPPORT_EMAIL_ADDRESS = "biz.support@blink.net";

export const TOP_UP_VALUES = [5, 10, 20, 50];

export const SIGNUP_EXTERNAL_URL = "signup-blink-service-external";

export const LOGIN_WITH_EMAIL_CODE_URL = "login-with-email-code-confirmation";

export const MOBILE_NAV_HEIGHT = 56;

export const AUTH_MODAL_CLOSE_TIMEOUT = 500;

export const STRIPE_CARD_ERROR_MAX_LENGTH = 60;

export const MODAL_TRANSITION_TIME = 150;

export const IOS_BOTTOM_OFFSET = 104;

export const DONATIONS_URL = "donations";

export const SUBSCRIPTIONS_URL = "subscriptions";
